import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/saas.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const SaasPlatforms = () => {
  const heroData = {
    title: "Enterprise SaaS Platform Development",
    description: "Build scalable, cloud-native SaaS platforms that drive recurring revenue and deliver exceptional value to your customers. We create subscription-based software solutions that scale from startup to enterprise.",
    image: img13,
    imageAlt: "SaaS Platforms",
    features: [
      "Cloud-native architecture",
      "Multi-tenant systems",
      "Subscription billing",
      "API-first approach",
      "Auto-scaling infrastructure",
      "Advanced analytics",
    ],
    pillars: [
      "Scalable architecture that grows with your user base",
      "Seamless user experience that drives adoption and retention",
      "Robust security and compliance for enterprise trust",
    ],
  };

  const journeySteps = [
    {
      title: "Market Research & Strategy",
      description: "We analyze your target market, competitive landscape, and business model to define a winning SaaS strategy and product roadmap.",
      details: ["Market analysis", "Competitor research", "Business model", "Product roadmap", "Pricing strategy", "Go-to-market plan"],
    },
    {
      title: "Architecture & Design",
      description: "Our experts design scalable multi-tenant architecture and intuitive user interfaces that deliver exceptional user experiences.",
      details: ["Multi-tenant design", "Cloud architecture", "UI/UX design", "Database schema", "API design", "Security framework"],
    },
    {
      title: "Development & Integration",
      description: "We build robust, cloud-native SaaS platforms using modern technologies, ensuring seamless integrations and API connectivity.",
      details: ["Cloud development", "API implementation", "Third-party integrations", "Payment systems", "Admin dashboard", "User management"],
    },
    {
      title: "Launch & Scale",
      description: "From beta testing to full launch, we ensure your platform scales smoothly with monitoring, optimization, and continuous improvements.",
      details: ["Beta testing", "Performance tuning", "Infrastructure scaling", "Launch coordination", "Monitoring setup", "Feature iterations"],
    },
  ];

  const capabilities = [
    {
      title: "Multi-Tenant Architecture",
      content:
        "Secure, scalable multi-tenant systems that efficiently serve multiple customers while maintaining data isolation and customization capabilities.",
    },
    {
      title: "Subscription Management",
      content:
        "Comprehensive billing, subscription, and license management systems with automated renewals, upgrades, and payment processing.",
    },
    {
      title: "API-First Development",
      content:
        "RESTful and GraphQL APIs that enable seamless integrations, third-party connectivity, and extensibility for your platform.",
    },
    {
      title: "Analytics & Insights",
      content:
        "Built-in analytics dashboards and reporting tools that provide actionable insights into user behavior, performance, and business metrics.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "10K+", label: "Users onboarded (first month)" },
      { value: "99.9%", label: "Platform uptime guarantee" },
      { value: "40%", label: "Faster time-to-market" },
    ],
    description: "We deliver SaaS platforms that achieve rapid user adoption, high retention rates, and scalable growth, powering successful subscription businesses.",
  };

  const outcomesData = {
    description: "We build production-ready SaaS platforms that combine enterprise-grade reliability with exceptional user experiences, enabling sustainable growth and competitive advantage.",
    outcomes: [
      "Multi-tenant architecture with data isolation",
      "Subscription billing and payment processing",
      "RESTful APIs for third-party integrations",
      "Real-time analytics and reporting dashboards",
      "Auto-scaling infrastructure for peak loads",
      "99.9% uptime with disaster recovery",
    ],
  };

  const whyChooseUs = [
    {
      title: "Cloud-Native Excellence",
      content:
        "We build platforms optimized for cloud infrastructure, ensuring high availability, auto-scaling, and cost-efficient operations.",
    },
    {
      title: "Security & Compliance",
      content:
        "Enterprise-grade security with compliance to GDPR, SOC 2, and industry standards, protecting your data and your customers.",
    },
    {
      title: "Rapid Development",
      content:
        "Agile methodology and modern DevOps practices enable faster time-to-market and continuous delivery of new features.",
    },
    {
      title: "Scalability Built-In",
      content:
        "Architecture designed to scale from startup to enterprise, handling millions of users without performance degradation.",
    },
  ];

  const faqs = [
    {
      q: "What's the typical cost to build a SaaS platform?",
      a: "SaaS development costs vary widely based on complexity, from $50K for an MVP to $500K+ for enterprise platforms. We provide detailed estimates after understanding your specific requirements and feature set.",
    },
    {
      q: "How do you handle multi-tenancy and data isolation?",
      a: "We implement secure multi-tenant architecture with complete data isolation between customers, ensuring each tenant's data is encrypted, separated, and accessible only to authorized users.",
    },
    {
      q: "Can you integrate subscription billing and payment processing?",
      a: "Yes! We integrate with platforms like Stripe, PayPal, and Chargebee for recurring billing, subscription management, invoicing, usage-based pricing, and automated payment processing.",
    },
    {
      q: "How do you ensure 99.9% uptime for SaaS platforms?",
      a: "We use cloud infrastructure with load balancing, auto-scaling, redundancy, automated backups, health monitoring, and disaster recovery procedures to maintain high availability and reliability.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"SaaS Platform Development"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our SaaS Platform Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default SaasPlatforms;
